"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _setConfig = _interopRequireDefault(require("../utils/setConfig"));

var _vue = _interopRequireDefault(require("vue"));

var _integrations = require("@sentry/integrations");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @function
 * @name SentryVueInit - vue版前端错误异常上报安装
 * @desc 前端配置错误异常上报及主动上报函数封装
 * @param {string} url 申请的异常上报系统地址
 * @param {object} cfg 配置
 * @param {boolean} cfg.senddev 是否在dev环境发送
 * @example
 * import { SentryInit } from '@zz-common/sentry';
 * 
 * SentryVueInit('url')
 * 
 * 
 * // sentry  接入例子
  useSentry() {
    tryCatch(() => {
      SentryVueInit('url')
    })
  }
  
  Vue.config.errorHandler = (err, vm, info) => {
    SentryCapture(err, 2)
  }
 */
var _default = function _default(url, cfg) {
  (0, _setConfig.default)(function (config) {
    Sentry.init(_objectSpread(_objectSpread({
      dsn: url
    }, config), {}, {
      integrations: [new _integrations.Vue({
        Vue: _vue.default,
        attachProps: true
      })]
    }));
  }, cfg);
};

exports.default = _default;